import { MyProfile, MyProfileErrorCode } from 'cpnl-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { MyProfileDataSelector } from './MyProfileDataSelector';
import { fetchMyProfile } from './MyProfileSlice';

export function useMyProfile(): AbstractDataState<MyProfile, MyProfileErrorCode> {
    return useGetSimpleApiData(fetchMyProfile, MyProfileDataSelector);
}
